<template>
  <div>
    <div v-if="message" class="alert py-2" :class="messageOk ? 'alert-success' : 'alert-warning'">{{ message }}</div>

    <h6 class="fw-bold">ADAS Map Provider Customer Email</h6>
    <p class="text-muted small">
      Sent by <strong>Email Customer</strong> on an inspection, with the ADAS Map report attached.
      Placeholders: [SHOPNAME] [CONTACTNAME] [VEHICLE] [VIN] [YEAR] [MAKE] [MODEL] [RONUMBER] [INSPECTION] [PROVIDERNAME]
      - they work in the subject as well as the body.
      [INSPECTION] [PROVIDERNAME]
    </p>

    <div class="row g-2 mb-2">
      <div class="col-4">
        <label class="custom-label">From Name</label>
        <input class="form-control form-control-sm" v-model="template.fromName" :disabled="busy" />
      </div>
      <div class="col-4">
        <label class="custom-label">From Email</label>
        <input class="form-control form-control-sm" type="email" v-model="template.fromEmail" :disabled="busy" />
      </div>
      <div class="col-4">
        <label class="custom-label">Subject</label>
        <input class="form-control form-control-sm" v-model="template.subject" :disabled="busy" />
      </div>
      <div class="col-12">
        <label class="custom-label">Body (HTML)</label>
        <textarea class="form-control form-control-sm custom-body" v-model="template.html" :disabled="busy"></textarea>
      </div>
      <div class="col-12">
        <label class="custom-label">Plain text fallback</label>
        <textarea class="form-control form-control-sm custom-body-plain" v-model="template.template" :disabled="busy"></textarea>
      </div>
    </div>
    <button class="btn btn-primary btn-sm" :disabled="busy" @click="saveTemplate">
      <span v-if="busy" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Save Template
    </button>

    <!-- Root-firm setting: one callout inherited by every provider, so only a super admin edits it. -->
    <div v-if="isSuperAdmin" class="custom-callout-block mt-4">
      <h6 class="fw-bold">ADAS Map Sign-Up Callout</h6>
      <p class="text-muted small mb-2">
        Appended to the bottom of every provider's customer email, across all providers. Set once here on
        the root firm.
      </p>
      <textarea class="form-control form-control-sm custom-body" v-model="callout" :disabled="busy"></textarea>
      <button class="btn btn-primary btn-sm mt-2" :disabled="busy" @click="saveCallout">
        <span v-if="busy" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Save Callout
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { customerStore } from '@/stores/customer'
export default {
  name: 'LocationCustomerEmail',
  props: {
    firm: Object
  },
  data() {
    return {
      template: { fromName: '', fromEmail: '', subject: '', html: '', template: '' },
      callout: '',
      busy: false,
      message: '',
      messageOk: false
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    isSuperAdmin() {
      return !!(this.profile && this.profile.roles && this.profile.roles[0] === 1)
    }
  },
  async mounted() {
    await this.load()
  },
  methods: {
    ...mapActions(customerStore, ['getEmailTemplate', 'saveEmailTemplate', 'getSignupCallout', 'saveSignupCallout']),
    async load() {
      this.busy = true
      try {
        this.template = (await this.getEmailTemplate()) || this.template
        if (this.isSuperAdmin) this.callout = await this.getSignupCallout()
      } catch (e) {
        this.setMessage('The customer email settings could not be loaded.', false)
      } finally {
        this.busy = false
      }
    },
    async saveTemplate() {
      this.busy = true
      try {
        await this.saveEmailTemplate(this.template)
        this.setMessage('Template saved.', true)
      } catch (e) {
        this.setMessage('The template could not be saved.', false)
      } finally {
        this.busy = false
      }
    },
    async saveCallout() {
      this.busy = true
      try {
        await this.saveSignupCallout(this.callout)
        this.setMessage('Callout saved.', true)
      } catch (e) {
        this.setMessage('The callout could not be saved.', false)
      } finally {
        this.busy = false
      }
    },
    setMessage(text, ok) {
      this.message = text
      this.messageOk = ok
      setTimeout(() => { this.message = '' }, 4000)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 2px;
}
.custom-body {
  min-height: 180px;
  font-family: monospace;
  font-size: 0.8rem;
}
.custom-body-plain {
  min-height: 100px;
  font-family: monospace;
  font-size: 0.8rem;
}
.custom-callout-block {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}
</style>
